import { ProjectEvent } from "./projectEvents";

// 부업(정규직의 프리랜서 의뢰) 시스템 상수.
export const SIDE_JOB_CAUGHT_CHANCE = 0.08; // 부업 작업 1회당 발각 확률

// 부업 수주 확인 모달 문구 (취업규칙 제7조)
export const SIDE_JOB_WARNING =
  "취업규칙 제7조: 겸업 금지.\n...들키지만 않으면 됩니다. 수주하시겠습니까?";

// 발각 이벤트 — 기존 이벤트 모달 UI를 재사용하지만 일반 풀(PROJECT_EVENTS)에는
// 포함되지 않고, 효과도 서버가 특수 분기로 처리한다 (고과/퇴사는 일반
// ProjectEventEffect로 표현할 수 없다).
export const SIDE_JOB_CAUGHT_EVENT_ID = "side_job_caught";

export const SIDE_JOB_CAUGHT_EVENT: ProjectEvent = {
  id: SIDE_JOB_CAUGHT_EVENT_ID,
  situation:
    "인사팀 차장이 모니터를 물끄러미 보다가 물었다. \"...그거, 회사 일 아니죠?\"",
  choices: [
    { id: "A", label: "시말서를 쓴다 (고과 -2)" },
    { id: "B", label: "\"개인 공부입니다\"라고 우긴다 (반반의 도박)" },
    { id: "C", label: "당당하게 퇴사한다 (부업이 본업이 된다)" },
  ],
};

export const SIDE_JOB_CAUGHT_PERF = {
  CONFESS: -2,       // A. 시말서
  DENY_FAIL: -3,     // B. 우기기 실패
  DENY_SUCCESS_CHANCE: 0.5,
} as const;
